import { createSelector } from 'reselect';
import { get } from 'lodash';
import READING_MODES from '../../data/reading_modes';

const getBookChaptersCount = state => get(state, 'bookInfo.chapters.length', 0);
const getPostReadingQuestions = state => get(state, 'postReading.remainingQuestions', []);

const getAvailableReadingModes = createSelector([
  getBookChaptersCount,
  getPostReadingQuestions,
], (chaptersCount, postReadingQuestions) => {
  const availableModes = [
    // we assume each book has challenge mode with inline activities
    READING_MODES.CHALLENGE,
  ];
  const challengeModeOnly = chaptersCount > 0;
  const hasPostReading = postReadingQuestions.length > 0;
  if (!challengeModeOnly) {
    availableModes.unshift(READING_MODES.CLEAN);
    if (hasPostReading) {
      availableModes.push(READING_MODES.POST);
    }
  }
  return availableModes;
});

export default getAvailableReadingModes;
